import { Box } from '@mui/material';
import { TopNavBar } from './navbar/topNavBar';
import { BottomNavBar } from './navbar/bottomNavBar';
export const Layout = ({ children }) => {
  return (
    <>
      <TopNavBar />
      {children}
      <BottomNavBar />
    </>
  );
};
